import { baseAxiosInstance } from '../axios-config';
import { OrderProductionItem, OrderProductionItemCreate } from './order-production-items.model';

export class OrderProductionItemsService {
  public static async create(newOrderData: OrderProductionItemCreate): Promise<OrderProductionItem[]> {
    const { data } = await baseAxiosInstance.post('/order-production-items/create', newOrderData);
    return data;
  }
}
